import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ConvertActionBindingResult } from '@angular/compiler/src/compiler_util/expression_converter';
import { Contacts } from 'src/app/models/contacts';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss']
})
export class Step3Component implements OnInit {
  @Input() Form: FormGroup;
  @Input() formattedDate: string;
  public showLoading: boolean = false;

  constructor(private contactService: ContactsService, private router: Router, ) { }

  ngOnInit() {
  }

  submit() {
    var pipe = new DatePipe("en-US");
    var c = new Contacts();
    c.firstName = this.Form.get('contactDataForm').get('firstName').value;
    c.lastName = this.Form.get('contactDataForm').get('lastName').value;
    c.email = this.Form.get('contactDataForm').get('email').value;
    c.phone = this.Form.get('contactDataForm').get('phone').value;
    // c.date = pipe.transform(this.Form.get('DateForm').get('date').value, "yyyy-MM-dd 00:00:00");
    // c.personNumber = this.Form.get('DateForm').get('personNumber').value;
    // c.message = this.Form.get('DateForm').get('message').value;
    c.visit = (this.Form.get('visit').value ? this.Form.get('visit').value : false);
    c.news = (this.Form.get('news').value ? this.Form.get('news').value : false);
    c.privacy = this.Form.get('privacy').value;
    c.terms = this.Form.get('terms').value;
    this.contactService.Insert(c).subscribe((r) => {
      this.router.navigate(['/confirm-reservation']);
    });
    this.showLoading = true;
  }

}
